<div
  class="w-full mt-5 md:mt-0"
  [formGroup]="form">
  <label
    for="comment"
    class="block">
    {{ "contactUsForm.comment.label" | translate }}
    <span
      *ngIf="spanMandatoryComment"
      class="text-red opacity-60"
      >*</span
    >
  </label>
  <textarea
    id="comment"
    formControlName="comment"
    maxlength="1000"
    class="mt-1 w-full p-2 border border-light rounded-md resize-none h-[110px] md:h-[220px]"
    [placeholder]="'contactUsForm.comment.placeholder' | translate"
    [ngClass]="{
      'bg-light': form.get('comment')?.disabled,
    }"
    (keydown)="onCommentKeyDown($event)"
    (input)="onCommentInput($event)"></textarea>
</div>
